import { useContext, useState } from 'react';
import ChallengeContext from '../../ChallengeContext';
import RowContext from '@/components/ChallengePortfolio/NormalView/Rows/Row/RowContext';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';
import useApi from '@/lib/api/useApi';
import useAddCopySuffix from '@/lib/utils/useAddCopySuffix';
import { type ChallengeSummary } from '@/lib/types';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { FileCopyOutlined as CopyIcon } from '@mui/icons-material';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';
import RequestPortfolioItemCloseContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemViewCardWithPageOverlay/ClosablePageOverlay/RequestPortfolioItemCloseContext';

type CopyChallengeProps = Omit<
  MenuItemProps,
  'onClick' | 'disabled' | 'children'
>;

const CopyChallenge = (props: CopyChallengeProps) => {
  const api = useApi();

  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);
  const row = useContext(RowContext);
  const [challenge] = useContext(ChallengeContext);

  const [copying, setCopying] = useState(false);

  const addCopySuffix = useAddCopySuffix();
  const requestChallengeClose = useContext(RequestPortfolioItemCloseContext);

  const copyChallenge = async (): Promise<void> => {
    setCopying(true);

    const challengeCopy = await api.post<ChallengeSummary>(
      `challenge-portfolio/challenges/${challenge.id}/copy`,
      {
        name: addCopySuffix(challenge.name),
      },
    );

    setChallengePortfolio(challengePortfolio => {
      challengePortfolio.rows[row.id].challenges.push(challengeCopy.id);
      challengePortfolio.challenges[challengeCopy.id] = challengeCopy;
    });

    setCopying(false);
    requestChallengeClose();
  };

  return (
    <MenuItem onClick={copyChallenge} disabled={copying} {...props}>
      <ListItemIcon>
        {copying ? <MenuItemLoadingIndicator /> : <CopyIcon />}
      </ListItemIcon>
      <ListItemText>
        <FormattedMessageWithChallengeNaming id="portfolio.challenge.options.copy.label" />
      </ListItemText>
    </MenuItem>
  );
};

export default CopyChallenge;
